import { AppMessage } from '@/common/components';
import { FC, memo, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';

import { AppRoutes } from '@/common/interfaces';
import { FallbackedLayout } from '@/common/layouts';
import { messageOnError } from '@/common/utils';

import { useDeleteComponentsPageMutation, useGetByIdComponentsPageQuery } from '@/modules/Pages';

import { PageComponentsQueryKeys } from '../../../../queries/pages.keys';
import { PageComponentsViewView } from './PageComponentsViewView';

interface Props {
  siteId: string;
  componentId: string;
}

export const PageComponentsViewContainer: FC<Props> = memo(({ siteId, componentId }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const appMessageApi = AppMessage.useControls();

  const { data, isLoading, error, isError } = useGetByIdComponentsPageQuery(componentId, siteId)();

  const { mutate: deleteComponentMutation, isLoading: isDeleteComponentLoading } = useDeleteComponentsPageMutation(componentId, siteId)({
    onSuccess: async () => {
      appMessageApi.success('Макет сторінки успішно видалено!');

      await queryClient.refetchQueries([PageComponentsQueryKeys.GetAll, siteId]);

      navigate(AppRoutes.SitesTemplates.replace(':siteId', siteId));
    },
    onError: (err) => {
      messageOnError(err, appMessageApi);
    }
  });

  const handleDeleteComponent = useCallback(() => {
    deleteComponentMutation();
  }, []);

  return (
    <FallbackedLayout
      isLoading={ isLoading }
      error={ error }
      isError={ isError }
      data={ data }
    >
      {
        (layout) => (
          <PageComponentsViewView
            component={ layout }
            isDeleteComponentLoading={ isDeleteComponentLoading }
            disableControlButtons={ isLoading }
            handleDeleteComponent={ handleDeleteComponent }
          />
        )
      }
    </FallbackedLayout>
  );
});
